import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'
import { PerformanceInsightsEmpty } from './PerformanceInsightsEmpty'
import { PerformanceInsightsWithIntegrations } from './PerformanceInsightsWithIntegrations'
import { Spinner } from 'components/MobileAutopilotCalendar/components/MobileToast/Spinner'
import Styles from './PerformanceInsights.module.scss'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { organicChannels } from '../InsightChannelsSelection/utils'
import { useState } from 'react'

export interface PerformanceInsightsProps {
  onNext: () => void
  onBack: () => void
  onSkip: () => void
  brandKitId: number
  insightChannels: string[]
}

export const PerformanceInsights = ({
  onNext,
  onBack,
  brandKitId,
  onSkip,
  insightChannels,
}: PerformanceInsightsProps) => {
  const [isConnecting, setIsConnecting] = useState(false)
  const { data, isLoading } = useBrandKit(brandKitId)
  const brandKit = data?.brand_kit
  const integrations = brandKit?.external_integrations

  const integration = organicChannels.find((channel) =>
    integrations?.some((integration) => integration.provider === channel.name),
  )

  if (isLoading) {
    return (
      <MultiStepStepLayout title="Your performance insights" description="Based on your last 30 days of posts">
        <div className={Styles.spinnerContainer}>
          <Spinner />
        </div>
      </MultiStepStepLayout>
    )
  }

  if (!integration && !isConnecting) {
    return (
      <PerformanceInsightsEmpty
        onBack={onBack}
        brandKitId={brandKitId}
        onSkip={onSkip}
        insightChannels={insightChannels}
        onConnecting={() => setIsConnecting(true)}
      />
    )
  }

  return (
    <PerformanceInsightsWithIntegrations
      isConnectingFirstIntegration={isConnecting}
      onNext={onNext}
      onBack={onBack}
      brandKitId={brandKitId}
      insightChannels={insightChannels}
    />
  )
}
